import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import * as actions from './actions';
import {
  getOrgWebhookTemplates,
  createOrgWebhookTemplate,
  updateOrgWebhookTemplate,
  deleteOrgWebhookTemplate,
} from '../../../lib/orgRequests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';

function extractError(e) {
  if (e.response && e.response.data) { return e.response.data; }
  return 'An unexpected error occurred';
}

export function* getOrgWebhookTemplatesRequestWatcher() {
  for (;;) {
    var request = yield take(types.GET_ORG_WEBHOOK_TEMPLATES_REQUEST);
    try {
      var response = yield call(getOrgWebhookTemplates, request.payload);
      yield put(actions.getOrgWebhookTemplatesSuccess(response.data));
    } catch (e) {
      yield put(actions.getOrgWebhookTemplatesFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* createOrgWebhookTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.CREATE_ORG_WEBHOOK_TEMPLATE_REQUEST);
    try {
      var response = yield call(
        createOrgWebhookTemplate,
        request.payload.organization_guid,
        request.payload
      );
      yield put(actions.createOrgWebhookTemplateSuccess(response.data));
    } catch (e) {
      yield put(actions.createOrgWebhookTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updateOrgWebhookTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.UPDATE_ORG_WEBHOOK_TEMPLATE_REQUEST);
    try {
      var response = yield call(
        updateOrgWebhookTemplate,
        request.payload.guid,
        request.payload.organization_guid,
        request.payload
      );
      yield put(actions.updateOrgWebhookTemplateSuccess(response.data));
    } catch (e) {
      yield put(actions.updateOrgWebhookTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* deleteOrgWebhookTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.DELETE_ORG_WEBHOOK_TEMPLATE_REQUEST);
    try {
      yield call(
        deleteOrgWebhookTemplate,
        request.payload.guid,
        request.payload.organization_guid
      );
      yield put(actions.deleteOrgWebhookTemplateSuccess(request.payload.guid));
    } catch (e) {
      yield put(actions.deleteOrgWebhookTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
